import type { ModuleCode } from '../../features/modules/modules';
import apiClient from '../index';

export const getDashboardOverview = async (module: ModuleCode) => {
	const response = await apiClient.get(
		`/dashboard?${new URLSearchParams({ module })}`,
	);
	return response.data;
};
